import { render, staticRenderFns } from "./SAPS.vue?vue&type=template&id=1051fa4c&scoped=true"
import script from "./SAPS.vue?vue&type=script&lang=js"
export * from "./SAPS.vue?vue&type=script&lang=js"
import style0 from "./SAPS.vue?vue&type=style&index=0&id=1051fa4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051fa4c",
  null
  
)

export default component.exports